import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

type Props = {
    username?: string;
    summary: any;
};

const buildTeamFundsMsg = (teamFundsUsd: number, teamFundsDisplay: number) => {
    if (teamFundsUsd > 0) {
        return `\n\n$${teamFundsDisplay} - средства команды на твоих счетах, с учетом переводов между тобой и командой. Делаю запрос на перевод команде.`;
    }
    if (teamFundsUsd < 0) {
        return `\n\n$${Math.abs(teamFundsDisplay)} команда должна тебе с учетом переводов между тобой и командой. Сделай запрос на эту сумму.`;
    }
    return `\n\nПри выводе средств обязательно используй функцию "ДВИЖЕНИЕ ЛИЧНЫХ СРЕДСТВ".`;
};

const PayoutMessageBox: React.FC<Props> = ({ username, summary }) => {
    const [copied, setCopied] = React.useState(false);

    const teamFundsMsg = buildTeamFundsMsg(summary.team_funds_usd, summary.team_funds_display);
    const msg = `${username}\n\nРезультат пакета: $${summary.bundle?.result}\nТвой процент: ${summary.total_payout_percent}%\n$${summary.bundle?.player_result} добавляю к "ЛИЧНЫМ СРЕДСТВАМ" и стартуем новый пакет!${teamFundsMsg}\n\nУдачи!🍀`;

    return (
        <div className="relative bg-gray-50 rounded p-4 text-lg font-light whitespace-pre-line mt-8">
            <Tooltip title="Копировать">
                <IconButton
                    size="small"
                    style={{ position: 'absolute', top: 8, right: 8 }}
                    onClick={() => {
                        navigator.clipboard.writeText(msg);
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                    }}
                >
                    {copied
                        ? <CheckIcon fontSize="small" style={{ color: '#16a34a' }} />
                        : <ContentCopyIcon fontSize="small" />
                    }
                </IconButton>
            </Tooltip>
            {msg}
        </div>
    );
};

export default PayoutMessageBox;
